import { useContext } from "react";
import { Context } from "../../../Store/Store";
import Nav from "./Nav";
import { brandImages } from "../../../theme/brandAssets";

const styles = {
  Sidebar: {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    backgroundColor: "var(--color-primary)",
    color: "white",
    gridRow: " 1/-1",
    height: "100vh",
  },
  Logo: {
    paddingLeft: "12px",
  },
};

function Sidebar() {
  const context = useContext(Context);
  const state = context[0];
  const userIsMember = state.user?.data?.group === "Member" || state.user?.data?.podAccess === true;

  return (
    <div style={styles.Sidebar}>
      <div>
        <a href="https://apps.kynzo.io" style={{ display: "block", marginBottom: userIsMember ? "1.5rem" : "2.5rem" }}>
          <img
            className="brand-logo-img"
            src={brandImages.wordmarkOnDark}
            alt="Kynzo"
            style={{ ...styles.Logo, maxHeight: 36 }}
          />
        </a>
      </div>
      <Nav />
    </div>
  );
}

export default Sidebar;
